import { memo } from 'react';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { getClickedToTogglePreviousMessageHistory } from '../../../usage-tracking/events/editorInteractions';
import { useAsyncPreviousMessageHistoryHtml } from 'conversations-thread-data/thread-history/public/hooks';
import MessageHistory, { MessageHistoryToggleButton } from './MessageHistory';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviousMessageHistory = ({
  threadId
}) => {
  const {
    asyncPreviousMessageHistoryHtml,
    fetchHistoryHtml
  } = useAsyncPreviousMessageHistoryHtml({
    threadId
  });
  return /*#__PURE__*/_jsx(MessageHistory, {
    asyncHistoryHtml: asyncPreviousMessageHistoryHtml,
    fetchHistoryHtml: fetchHistoryHtml
  });
};
PreviousMessageHistory.displayName = 'PreviousMessageHistory';
const PreviousMessageHistoryWrapper = /*#__PURE__*/memo(({
  threadId,
  containerClass = 'previous-message-history-container'
}) => {
  const onClickTracker = showMessageHistory => {
    trackEvent(getClickedToTogglePreviousMessageHistory({
      direction: showMessageHistory ? 'Closed' : 'Opened'
    }));
  };
  return /*#__PURE__*/_jsx(MessageHistoryToggleButton, {
    historyContent: /*#__PURE__*/_jsx(PreviousMessageHistory, {
      threadId: threadId
    }),
    msgHistoryId: threadId,
    onClickTracker: onClickTracker,
    containerClass: containerClass
  });
});
PreviousMessageHistoryWrapper.displayName = 'PreviousMessageHistoryWrapper';
export default PreviousMessageHistoryWrapper;